import { render } from "./MbrandIndex.vue?vue&type=template&id=287dcff6&scoped=true"
import script from "./MbrandIndex.vue?vue&type=script&lang=js"
export * from "./MbrandIndex.vue?vue&type=script&lang=js"

import "./MbrandIndex.vue?vue&type=style&index=0&id=287dcff6&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287dcff6"]])

export default __exports__